<template>
    <div>
        <div v-if="activeLayout === 0">
            <courses-table-component
                :uuid_client="uuid_client"
                :url_get="url_get"
                :url_get_users="url_get_users"
                :url_get_own_courses="url_get_own_courses"
                :url_report="url_report_courses"
                :url_report_detail="url_report_courses_detail"
                :url_report_detail_v2="url_report_courses_detail_v2"
                :url_delete_own_course="url_delete_own_course"
                @onViewCourseUsers="onViewCourseUsers"
                @onEditCourse="onUpdateCourseView"
            ></courses-table-component>
            <courses-catalog-component
                :url_courses_wp="url_courses_wp"
                :url_routes_by_company="url_routes_by_company"
            ></courses-catalog-component>
            <courses-ranking-component
                :url="url_get_courses_ranking"
                :url_report="url_report_ranking_courses"
            ></courses-ranking-component>
            <own-courses-create-component
                :url_create_course="url_create_own_course"
                @onRefreshData="onCourseCreated"
            ></own-courses-create-component>
        </div>

        <courses-users-component v-if="activeLayout === 1" :course="activeCourse" :url="url_get_courses_users" @onBack="clearActiveCourse" ></courses-users-component>

        <own-courses-edit-component
            v-if="activeLayout === 2"
            :url_update_course="url_update_own_course"
            :courseId="activeCourse"
            @onBack="cancelEditingCourse"
            @onSaved="onCourseUpdated"
        ></own-courses-edit-component>
    </div>
</template>

<script>
    export default {
        props: [
            "uuid_client",
            "url_get",
            "url_get_users",
            "url_get_own_courses",
            "url_get_courses_ranking",
            "url_get_courses_users",
            "url_report_courses",
            "url_report_courses_detail",
            "url_report_courses_detail_v2",
            "url_create_own_course",
            "url_report_ranking_courses",
            "url_courses_wp",
            "url_update_own_course",
            "url_delete_own_course",
            "url_routes_by_company"
        ],
        data() {
            return {
                activeLayout: 0,
                activeCourse: null,
            }
        },
        mounted(){

        },
        methods:{
            onViewCourseUsers(courseId){
                this.activeCourse = courseId;
                this.activeLayout = 1;
            },
            clearActiveCourse(){
                this.activeCourse = null;
                this.activeLayout = 0;
            },
            onUpdateCourseView(courseId){
                this.activeCourse = courseId;
                this.activeLayout = 2;
            },
            updateCourses(){
                this.$emit('onRefreshData');
            },
            cancelEditingCourse(){
                this.activeCourse = null;
                this.activeLayout = 0;
            },
            onCourseUpdated(){
                this.activeCourse = null;
                this.activeLayout = 0;
                this.updateCourses();
            },
            onCourseCreated(){
                this.activeCourse = null;
                this.updateCourses();
            }
        }
    }
</script>

<style>

</style>
